import { Flex, Spin } from "antd";

const Spinner = () => (
  <Flex align="center" justify="center" className="page-spinner">
    <Spin size="large" />
  </Flex>
);

export default Spinner;
